import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { getProductInfo, creditsRedeem } from '@/api/shop';
import { mixins } from '@/mixins';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import Button from '@/components/Button/Button.vue';
import Dialog from '@/components/Dialog/Dialog.vue';

export default {
  components: {
    AreaLoading,
    Button,
    Dialog
  },
  
  name: 'Product',

  mixins: [mixins],

  data() {
    return {
      firstLoading: false,
      productInfo: {},
      buying: false
    }
  },

  computed: {
    ...mapGetters([
      'pageBackgroundColor',
      'cardBackgroundColor',
      'hignlightBorderColor',
      'cardBtnBackgroundColor',
      'primaryBtnBackgroundColor',
      'virtualCurrencyUnit'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.firstLoading = true;
      this.productList = [];
      await this.getProductInfo();
      this.firstLoading = false;
    },

    async getProductInfo(opts) {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const productId = this.$route.query.id;
      const res = await getProductInfo({
        token,
        appid,
        productId
      });

      this.productInfo = res.data;
    },

    clickBootsCardTipsButton() {
      this.hideTips();
      this.buy();

    },

    showTips() {
      this.$refs.bootsCardRule.show();
    },

    hideTips() {
      this.$refs.bootsCardRule.hide();
    },

    async buy() {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;

      if (this.buying) {
        return;
      }

      this.buying = true;

      try {
        const res = await creditsRedeem({
          token,
          appid,
          sku_id: this.productInfo.sku_id
        });

        this.$message({
          message: 'Boost Card +1',
          type: 'success',
          showClose: false,
          customClass: 'custom-message',
          during: 3000
        });
      }
      catch(err) {
        if (err.code && err.message) {
          this.$message({
            message: err.message,
            type: 'error',
            showClose: false,
            customClass: 'custom-message',
            during: 10000
          });
        }
        else {
          this.$message({
            message: 'system error',
            type: 'error',
            showClose: false,
            customClass: 'custom-message',
            during: 10000
          });
        }
      }
      
      this.buying = false;
    }
  }
}



